'use strict';

// Import Libraries
import React from 'react';
import classNames from 'classnames';
import { builderDispatch } from '../_utils/ui';
import ShelfEvents from '../_shelf-category/flux-events';
import translate from '../_utils/tools/translate';

const Favouritable = ({ favourited, designCode, newUi }) => {
  const iconClass = favourited ? 'selected fas fa-heart' : 'far fa-heart';
  const favourite_class = newUi
    ? 'new-favouritable float-right'
    : 'favouritable';

  const favouriteLabel = favourited
    ? `To Remove ${translate('favorite')} from this design`
    : `${translate('Favorite')} this design`;

  return (
    <button
      className={`btn btn-link ${favourite_class}`}
      aria-label={favouriteLabel}
      onClick={toggleFavourite}
      role="checkbox"
      aria-checked={favourited}>
      <i className={classNames(iconClass, { 'float-right': newUi })} />
    </button>
  );

  function toggleFavourite(e) {
    e.preventDefault();
    e.stopPropagation();

    builderDispatch.dispatch({
      type: ShelfEvents.FAVOURITED,
      designCode,
    });

    const data = new FormData();
    data.append('design_code', designCode);
    data.append('checked', !favourited);

    fetch('/favourites', {
      method: 'PUT',
      credentials: 'same-origin',
      body: data,
    });
  }
};

Favouritable.displayName = 'Favouritable';

export default Favouritable;
